import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const UserStatusIndicator = () => {
  const [userStatus, setUserStatus] = useState('available');
  const [userName] = useState('Agent Smith');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const statusOptions = [
    {
      value: 'available',
      label: 'Available',
      icon: 'CheckCircle',
      className: 'status-available'
    },
    {
      value: 'busy',
      label: 'Busy',
      icon: 'XCircle',
      className: 'status-busy'
    },
    {
      value: 'away',
      label: 'Away',
      icon: 'Clock',
      className: 'status-away'
    }
  ];

  const currentStatus = statusOptions?.find(status => status?.value === userStatus);

  const handleStatusChange = (newStatus) => {
    setUserStatus(newStatus);
    setIsDropdownOpen(false);
    
    // Simulate WebSocket status update
    console.log(`Status changed to: ${newStatus}`);
  };

  const handleClickOutside = (event) => {
    if (!event?.target?.closest('.status-dropdown')) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="fixed top-4 right-4 z-1010">
      <div className="flex items-center space-x-3 bg-white rounded-lg shadow-subtle border border-slate-200 px-3 py-2">
        {/* User Info */}
        <div className="hidden sm:flex items-center space-x-2">
          <div className="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center">
            <Icon name="User" size={16} color="var(--color-text-secondary)" />
          </div>
          <span className="text-sm font-medium text-slate-900">{userName}</span>
        </div>

        {/* Status Indicator */}
        <div className="relative status-dropdown">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className={`status-indicator micro-hover micro-click focus-ring ${currentStatus?.className}`}
            title={`Current status: ${currentStatus?.label}`}
          >
            <Icon name={currentStatus?.icon} size={14} className="mr-1" />
            <span className="hidden sm:inline">{currentStatus?.label}</span>
            <Icon name="ChevronDown" size={12} className="ml-1" />
          </button>

          {/* Status Dropdown */}
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-elevated border border-slate-200 py-1 fade-in">
              {statusOptions?.map((status) => (
                <button
                  key={status?.value}
                  onClick={() => handleStatusChange(status?.value)}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex items-center space-x-2 micro-hover ${
                    status?.value === userStatus ? 'bg-slate-50' : ''
                  }`}
                >
                  <Icon name={status?.icon} size={16} />
                  <span>{status?.label}</span>
                  {status?.value === userStatus && (
                    <Icon name="Check" size={14} className="ml-auto text-primary" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Notification Badge */}
        <div className="relative">
          <button className="p-1 text-slate-600 hover:text-slate-900 micro-hover focus-ring rounded">
            <Icon name="Bell" size={18} />
          </button>
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-error rounded-full flex items-center justify-center">
            <span className="text-xs text-white font-medium">3</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStatusIndicator;